import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../store/ui-gemini";

const SubscriptionRequiredModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((s) => s.ui.isSubscriptionModalOpen);
  if (!open) return null;

  const close = (e) => {
    e?.stopPropagation?.();
    dispatch(uiAction.closeSubscriptionModal());
  };

  const gotoSubscribe = () => {
    window.location.href = "/subs";
  };

  return (
    <div onClick={close} className="fixed inset-0 z-[65] flex items-center justify-center bg-black/60">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-xl w-[90vw] max-w-sm p-5 text-left">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Subscribers only content</h3>
        <p className="text-sm text-gray-600 mb-4">
          This content is available for subscribers. Please subscribe to access Courses and Video Library.
        </p>
        <div className="flex gap-3 justify-end">
          <button onClick={gotoSubscribe} className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 active:scale-[0.98]">Go to Subscribe</button>
          <button onClick={close} className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 active:scale-[0.98]">Maybe later</button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequiredModal;


